document.addEventListener("DOMContentLoaded", () => {
const hdr_cd_carousel = document.getElementById("hdr_cd_carousel");

const hdr_cd_carousel_slides =
  document.getElementById("hdr_cd_carousel_slides");

const hdr_cd_carousel_slideCount =
  document.querySelectorAll(".hdr_cd_carousel_slide").length;

let hdr_cd_carousel_index = 0;
let hdr_cd_carousel_autoSlide;

/* Show Slide */
function hdr_cd_carousel_showSlide() {

  hdr_cd_carousel_slides.style.transform =
    `translateX(-${hdr_cd_carousel_index * 100}%)`;

}

/* Next Slide */
function hdr_cd_carousel_nextSlide() {

  hdr_cd_carousel_index =
    (hdr_cd_carousel_index + 1) %
    hdr_cd_carousel_slideCount;

  hdr_cd_carousel_showSlide();

}

/* Previous Slide */
function hdr_cd_carousel_prevSlide() {

  hdr_cd_carousel_index =
    (hdr_cd_carousel_index - 1 +
    hdr_cd_carousel_slideCount) %
    hdr_cd_carousel_slideCount;

  hdr_cd_carousel_showSlide();

}

/* Start Auto Slide */
function hdr_cd_carousel_startAutoSlide() {

  hdr_cd_carousel_autoSlide = setInterval(() => {

    hdr_cd_carousel_nextSlide();

  }, 3000);

}

/* Stop Auto Slide */
function hdr_cd_carousel_stopAutoSlide() {

  clearInterval(hdr_cd_carousel_autoSlide);

}

/* Button Events */
document
  .getElementById("hdr_cd_carousel_next")
  .addEventListener("click", () => {

    hdr_cd_carousel_nextSlide();

});

document
  .getElementById("hdr_cd_carousel_prev")
  .addEventListener("click", () => {

    hdr_cd_carousel_prevSlide();

});

/* Pause On Hover */
hdr_cd_carousel.addEventListener("mouseenter", () => {

  hdr_cd_carousel_stopAutoSlide();

});

/* Resume On Leave */
hdr_cd_carousel.addEventListener("mouseleave", () => {

  hdr_cd_carousel_stopAutoSlide();
  hdr_cd_carousel_startAutoSlide();

});

/* Init */
hdr_cd_carousel_startAutoSlide();

});